import React, {PureComponent} from "react";
import AddingText from "./AddingText";
import AddingPicture from "./AddingPicture";

export class ObjectManager extends PureComponent {
  render() {
    return (
      <div className="object-manager">
        <div className="object-manager__left">
          <AddingPicture />
        </div>
        <div className="object-manager__right">
          <AddingText />
        </div>
      </div>
    );
  }
}

export default ObjectManager;
